export default __webpack_public_path__ + "static/media/imgOrina.ee27fdca.png";